import { ProfileCustomValuesList } from "PFApp/components/custom_values_list";
import { Icon } from "PFComponents/icon";
import { Profile, ProfileCustomValue } from "PFTypes";
import { useEffect, useState } from "react";

import css from "./skills_category_section.module.scss";

type SkillCategorySectionProps = {
  name: string;
  values: ProfileCustomValue[];
  expanded: boolean;
  profile: Profile;
};

export const SkillCategorySection = ({ name, values, expanded, profile }: SkillCategorySectionProps) => {
  const [displayed, setDisplayed] = useState(false);

  useEffect(() => {
    setDisplayed(expanded);
  }, [expanded]);

  return (
    <div className={css.root} data-qa-id="skills-category">
      <button className={css.title} onClick={() => setDisplayed(!displayed)}>
        <span className={css.text}>
          {name} ({values.length})
        </span>
        <Icon name={displayed ? "subtract" : "add"} size="sm" />
      </button>
      <div className={css.body} style={{ display: displayed ? "block" : "none" }}>
        <ProfileCustomValuesList
          customFieldName="skills"
          customValues={values}
          profileId={profile.id}
          limit={20}
        />
      </div>
    </div>
  );
};
